import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useBrandRegistrationVerificationService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingGetVerification, setFetchingGetVerification] = useState(false);
    const [fetchingShowVerification, setFetchingShowVerification] = useState(false);
    const [fetchingStoreVerification, setFetchingStoreVerification] = useState(false);
    const [fetchingUpdateVerification, setFetchingUpdateVerification] = useState(false);
    const [fetchingGetById, setFetchingGetById] = useState(false);
    const [fetchingMarkAsPaid, setFetchingMarkAsPaid] = useState(false);

    const BASE_PATH = 'brand-registrations/brand-registrations';

    const getVerificationByBrandRegistration = (brand_registration_id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/${brand_registration_id}/verification`),
            setFetching: setFetchingGetVerification
        });
    };

    const showVerification = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/verification/${id}/show`),
            setFetching: setFetchingShowVerification
        });
    };

    const storeVerification = (brand_registration_id: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/${brand_registration_id}/verification/store`),
            body: data,
            setFetching: setFetchingStoreVerification
        });
    };

    const updateVerification = (verification_id: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/verification/${verification_id}/update`),
            body: data,
            setFetching: setFetchingUpdateVerification
        });
    };

    const getVerificationById = async (id: number, events: ServiceEvents = {}): Promise<any> => {
        return new Promise((resolve, reject) => {
            doGet({
                ...events,
                url: buildEndpoint(`brand-registrations/brand-registrations/verification/${id}/show`),
                setFetching: setFetchingGetById,
                onSuccess: (response) => {
                    resolve(response);
                },
                onError: (error) => {
                    reject(error);
                }
            });
        });
    };

    const markAsPaid = (verification_id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/verification/mark-as-paid`),
            body: { verification_id },
            setFetching: setFetchingMarkAsPaid
        });
    };

    return {
        fetchingGetVerification,
        fetchingShowVerification,
        fetchingStoreVerification,
        fetchingUpdateVerification,
        fetchingGetById,
        fetchingMarkAsPaid,
        getVerificationByBrandRegistration,
        showVerification,
        storeVerification,
        updateVerification,
        getVerificationById,
        markAsPaid
    };
};

export default useBrandRegistrationVerificationService;

